import { Routes } from "@angular/router";
import { FuelManagementComponent } from "./fuel-management.component";
import { appAuthGuard } from "../_shared/guards/app-auth.guard";
import { FuelDashboardComponent } from "./fuel-dashboard/fuel-dashboard.component";
import { AtgDashboardComponent } from "./atg-dashboard/atg-dashboard.component";
import { FuelChangesComponent } from "./fuel-changes/fuel-changes.component";
import { FuelLevelComponent } from "./fuel-level/fuel-level.component";
import { FuelConsumptionComponent } from "./fuel-consumption/fuel-consumption.component";
import { FuelReconciliationComponent } from "./fuel-reconciliation/fuel-reconciliation.component";
import { FuelPerformanceComponent } from "./fuel-performance/fuel-performance.component";
import { FuelChangesMapComponent } from "./fuel-changes/components/fuel-changes-map/fuel-changes-map.component";
import { FuelLevelMapComponent } from "./fuel-level/components/fuel-level-map/fuel-level-map.component";
import { FuelDashboardMapComponent } from "./fuel-dashboard/components/fuel-dashboard-map/fuel-dashboard-map.component";
import { fuelManagementGuard } from "../_shared/guards/beta-user.guard";

export const fuelManagementRoutes: Routes = [
  {
    path: 'fuel-management',
    component: FuelManagementComponent,
    canActivate: [appAuthGuard, fuelManagementGuard],
    children: [
      { path: 'fuel', component: FuelDashboardComponent },
      { path: 'fuel/fuel-dashboard-map', component: FuelDashboardMapComponent },
      { path: 'atg', component: AtgDashboardComponent },
      { path: 'fuel-changes', component: FuelChangesComponent },
      { path: 'fuel-changes/fuel-changes-map', component: FuelChangesMapComponent },
      { path: 'fuel-level', component: FuelLevelComponent },
      { path: 'fuel-level/fuel-level-map', component: FuelLevelMapComponent },
      { path: 'fuel-consumption', component: FuelConsumptionComponent },
      { path: 'fuel-reconciliation', component: FuelReconciliationComponent },
      { path: 'performance', component: FuelPerformanceComponent },
      { path: '', redirectTo: 'fuel', pathMatch: 'full' },
    ],
  },
]